module.exports = __webpack_public_path__ + "static/media/logo2.cc4a161a.png";